import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    num: 'TOMO 1',
    title: 'ECONOMÍA BLINDADA',
    desc: 'Reprogramá tu relación con el dinero desde la raíz. Los 7 votos de pobreza que heredaste. Anclajes de abundancia. PNL para el estrés financiero. Cómo generar y gestionar con soberanía en contexto de inflación y crisis argentina.'
  }, {
    num: 'TOMO 2',
    title: 'RELACIONES MAGNÉTICAS',
    desc: 'El sistema completo para transformar tus vínculos. Rapport, calibración y comunicación de poder. Cómo detectar vínculos tóxicos. Magnetismo personal y construcción de red estratégica en Argentina.'
  }, {
    num: 'TOMO 3',
    title: 'ALQUIMIA HOLÍSTICA',
    desc: 'Integrá PNL con espiritualidad, energía y propósito. Chakras, manifestación y rituales desde una perspectiva práctica y moderna. Sanación del linaje y coherencia entre mente, cuerpo y espíritu.'
  }, {
    num: 'TOMO 4',
    title: 'SALUD NEURO-INMUNE',
    desc: 'El cuerpo como aliado, no como archivo de trauma. Conexión entre estrés, inmunidad y sistema nervioso. PNL somática. Nutrición y movimiento como medicina. Protocolos de recuperación para el contexto argentino.'
  }, {
    num: 'TOMO 5',
    title: 'PROPÓSITO Y CARRERA',
    desc: 'Reinventate profesionalmente con dirección clara. Encontrá tu Ikigai. Monetizá tus talentos. Construí tu identidad profesional soberana. Cómo avanzar en carrera o emprendimiento con el país como está.'
  }, {
    num: 'TOMO 6',
    title: 'MAESTRÍA EMOCIONAL',
    desc: 'El sistema definitivo para gobernar tu mundo interior. Regulación emocional de alta performance. Blindaje ante la toxicidad del entorno. Identidad soberana. El plan maestro de los 12 meses de vida soberana.'
  }];
  const includes = ['Protocolos paso a paso', 'Ejercicios escritos con guía', 'Técnicas de PNL aplicadas', 'Checklists de implementación', 'Contexto 100% argentino'];
  return <section className="py-20 md:py-32 px-4 relative" data-id="element-303">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-304" />

      <div className="max-w-6xl mx-auto" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-306">
          <div className="inline-block mb-4" data-id="element-307">
            <span className="text-gold text-4xl" data-id="element-308">🏆</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-309">
            MEGAPACK SISTEMA SOBERANO
          </h2>
          <p className="text-xl text-gold-light font-medium mb-2" data-id="element-310">
            6 Tomos + 6 Bonos — PNL Aplicada al Contexto Argentino
          </p>
          <p className="text-gray-400" data-id="element-311">
            480+ páginas — Todo el sistema completo.
          </p>
        </motion.div>

        <div className="text-center mb-12" data-id="element-312">
          <h3 className="text-2xl font-bold text-white flex items-center justify-center gap-3" data-id="element-313">
            <span className="text-3xl" data-id="element-314">🧠</span> 6 TOMOS COMPLETOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-315">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl hover:border-gold/40 transition-all group relative overflow-hidden" data-id="element-316">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-317" />

              <div className="text-gold font-bold text-sm tracking-widest mb-2" data-id="element-318">
                {tomo.num}
              </div>
              <h4 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-319">
                {tomo.title}
              </h4>
              <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-320">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-lighter border border-dark-border rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-321">
          <h4 className="text-xl font-bold text-white mb-8 text-center" data-id="element-322">
            Cada tomo incluye:
          </h4>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-323">
            {includes.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-324">
                <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-325" />
                <span className="text-gray-200 font-medium" data-id="element-326">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}